import React from "react";

interface Props {
  title: string;
  subtitle: string;
  img: React.ReactNode;
}

export function Header({ title, subtitle, img }: Props) {
  return (
    <div className="flex flex-col items-center">
      <h2 className="text-lg font-semibold m-0 mb-1 flex">
        {title}
        {img}
      </h2>
      <p className="text-xs text-zinc-500 font-light m-0">{subtitle}</p>
    </div>
  );
}
